<script setup lang="ts">
import { InputComponent } from '../../../'
import { UTM_PARAMETER_KEY_OPTIONS } from '../../../../constants'
import type { UtmCriterion } from '../../../../types'
import CriteriaEnumSelect from '../CriteriaEnumSelect.vue'
import CriteriaFieldCell from '../CriteriaFieldCell.vue'
import { useCriterionField } from '../useCriterionField'

const props = defineProps<{
  row: UtmCriterion
  isDisabled?: boolean
}>()
const emits = defineEmits<(e: 'update:row', row: UtmCriterion) => void>()

const utmKey = useCriterionField(props, emits, 'utmKey')

const handleValueInput = (value: string | number | null) => {
  emits('update:row', { ...props.row, value: String(value ?? '') })
}
</script>

<template>
  <div class="utm-fields">
    <CriteriaFieldCell>
      <CriteriaEnumSelect
        v-model="utmKey"
        :is-disabled="isDisabled"
        :options="UTM_PARAMETER_KEY_OPTIONS"
        placeholder="Parameter"
        size="large"
      />
    </CriteriaFieldCell>
    <CriteriaFieldCell>
      <InputComponent
        :is-disabled="isDisabled"
        type="text"
        placeholder="Enter parameter"
        :model-value="row.value"
        @update:model-value="handleValueInput"
      />
    </CriteriaFieldCell>
  </div>
</template>

<style scoped lang="scss">
.utm-fields {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
}
</style>
